import React from 'react';
import { defineMessages } from 'react-intl';
import Message from 'components/Message';
import PropTypes from 'prop-types';

const messages = defineMessages({
  otherICal: {
    id: 'appointments.calendar-links.cta.other-icalendar',
    defaultMessage: 'Other - iCalendar',
  },
  otherGoogleCalendar: {
    id: 'appointments.calendar-links.cta.other-google-calendar',
    defaultMessage: 'Other - Google Calendar',
  },
  otherNotListed: {
    id: 'appointments.calendar-links.cta.other-not-listed',
    defaultMessage: 'Other - Not Listed',
  },
});

export const ENTITY_TYPES = {
  VENUE: 'VENUE',
  TEACHER: 'TEACHER',
};

export const CALENDAR_SOURCES = {
  ICAL: 'ICAL',
  GCAL: 'GCAL',
  NOT_LISTED: 'NOT_LISTED',
  FULLY_INTEGRATED: 'FULLY_INTEGRATED',
};

export const TEACHER_AVAILABILITY = {
  AVAILABLE: 'AVAILABLE',
  UNAVAILABLE: 'UNAVAILABLE',
};

export const CALENDAR_LINK_LEARN_MORE_HREF =
  'https://partnersupport.classpass.com/help/s/article/what-is-calendarsync-for-wellness';

const CALENDAR_LINK_MESSAGE_BY_SOURCE = {
  [CALENDAR_SOURCES.GCAL]: messages.otherGoogleCalendar,
  [CALENDAR_SOURCES.ICAL]: messages.otherICal,
  [CALENDAR_SOURCES.NOT_LISTED]: messages.otherNotListed,
};
export const getPlatformDisplayName = source =>
  CALENDAR_LINK_MESSAGE_BY_SOURCE[source] ? <Message message={CALENDAR_LINK_MESSAGE_BY_SOURCE[source]} /> : source;

export const CALSYNC_TUTORIAL_MODAL_VIEWED_STORAGE_KEY = 'calSyncTutorialModalViewed';

export const BOOKABLE_TYPES = {
  PRACTITIONER: 'PRACTITIONER',
  RESOURCE: 'RESOURCE',
};
export const teacherShape = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  icalExportKey: PropTypes.string,
  calendars: PropTypes.arrayOf(
    PropTypes.shape({
      entityId: PropTypes.number,
      entityType: PropTypes.string,
      source: PropTypes.string,
      url: PropTypes.string,
    })
  ),
});

export const googleCalendarShape = PropTypes.shape({
  description: PropTypes.string,
  id: PropTypes.string,
  summary: PropTypes.string,
  url: PropTypes.string,
});
